export default [
	{
		title: '2025-06-12',
		description: 'Executive Minutes',
		executive: true,
		href: '/minutes/executive/2025-06-12.pdf',
	},
	{
		title: '2025-06-12',
		description: 'General Minutes',
		href: '/minutes/2025-06-12.pdf',
	},
	{
		title: '2025-05-01',
		description: 'General Minutes',
		href: '/minutes/2025-05-01.pdf',
	},
	{
		title: '2025-04-10',
		description: 'Executive Minutes',
		executive: true,
		href: '/minutes/executive/2025-04-13.pdf',
	},
	{
		title: '2025-04-10',
		description: 'General Minutes',
		href: '/minutes/2025-04-10.pdf',
	},
	{
		title: '2025-03-13',
		description: 'Executive Minutes',
		executive: true,
		href: '/minutes/executive/2025-03-13.pdf',
	},
	{
		title: '2025-03-13',
		description: 'General Minutes',
		href: '/minutes/2025-03-13.pdf',
	},
	{
		title: '2025-02-06',
		description: 'General Minutes',
		href: '/minutes/2025-02-06.pdf',
	},
	{
		title: '2025-01-09',
		description: 'General Minutes',
		href: '/minutes/2025-01-09.pdf',
	},
	{
		title: '2024-12-12',
		description: 'General Minutes',
		href: '/minutes/2024-12-12.pdf',
	},
	{
		title: '2024-11-14',
		description: 'General Minutes',
		href: '/minutes/2024-11-14.pdf',
	},
	{
		title: '2024-10-10',
		description: 'General Minutes',
		href: '/minutes/2024-10-10.pdf',
	},
	{
		title: '2024-09-12',
		description: 'General Minutes',
		href: '/minutes/2024-09-12.pdf',
	},
	{
		title: '2024-08-08',
		description: 'General Minutes',
		href: '/minutes/2024-08-08.pdf',
	},
	{
		title: '2024-05-02',
		description: 'General Minutes',
		href: '/minutes/2024-05-02.pdf',
	},
	{
		title: '2024-04-04',
		description: 'General Minutes',
		href: '/minutes/2024-04-04.pdf',
	},
	{
		title: '2024-03-07',
		description: 'General Minutes',
		href: '/minutes/2024-03-07.pdf',
	},
	{
		title: '2024-02-01',
		description: 'General Minutes',
		href: '/minutes/2024-02-01.pdf',
	},
	{
		title: '2024-01-04',
		description: 'General Minutes',
		href: '/minutes/2024-01-04.pdf',
	},
	{
		title: '2023-12-06',
		description: 'General Minutes',
		href: '/minutes/2023-12-06.pdf',
	},
	{
		title: '2023-10-28',
		description: 'General Minutes',
		href: '/minutes/2023-10-28.pdf',
	},
]
